import G6, { TreeGraph } from '@antv/g6/dist/g6.min';
import {
  rightsOperationsOptionsKeyMap,
  rightsOperationsOptionsMap,
  rightsOperationsTimesOptionsKeyMap,
  rightsOperationsTimesOptionsMap
} from '../options';
import { generateActionBar } from './common';
import {
  conditionContentPaddingY,
  conditionRowHeight,
  conditionRowInnerHeight,
  conditionTitleHeight,
  CustomNodeType
} from './config';

const activityTypeHTML = {
  DIRECT_DESCENT: '<span style="font-size:14px;color:#333;">按关联商品清单特价价格/特价扣率执行</span>'
};
export const registerRightsInfoShape = (treeGraph: TreeGraph) => {
  G6.registerNode(CustomNodeType.RIGHTS_INFO, {
    draw: (cfg, group) => {
      const jsonData:any = cfg.jsonData;
      const conditionHtml = `
      <div style="display: flex;align-items: center;column-gap: 4px;height: ${conditionRowHeight}px">
      ${
        activityTypeHTML[`${(cfg as any).activityType}`]
          ? activityTypeHTML[`${(cfg as any).activityType}`]
          : `<select disabled data-id="${
              cfg!.id
            }" class="rightsinfo-col-1-select condition-select" style="height: ${conditionRowInnerHeight}px;" placeholder="">
        ${rightsOperationsOptionsMap[(cfg as any).activityType].reduce(
          (t, c) =>
            t +
            `<option value="${c.value}" ${
              jsonData?.equityInformationRule?.[rightsOperationsOptionsKeyMap[(cfg as any).activityType]] == c.value
                ? 'selected'
                : ''
            }  ${(cfg!.col1DisabledOptions as string[]).includes(c.value) ? 'disabled' : ''}>${c.label}</option>`,
          ''
        )}
        </select>
        ${
           ((cfg as any).activityType === 'FULL_SUB' &&
            jsonData?.equityInformationRule?.reductionOption === 'DISCOUNT_RATE') ||
          (cfg as any).activityType === 'SECKILL'
            ? ''
            : `<select disabled data-id="${
                cfg!.id
              }" class="rightsinfo-col-1-select condition-select" style="height: ${conditionRowInnerHeight}px;" placeholder="">
        ${rightsOperationsTimesOptionsMap[(cfg as any).activityType].reduce(
          (t, c) =>
            t +
            `<option value="${c.value}" ${
              (cfg!.jsonData as any).equityInformationRule[
                rightsOperationsTimesOptionsKeyMap[(cfg as any).activityType]
              ] == c.value
                ? 'selected'
                : ''
            }>${c.label}</option>`,
          ''
        )}
        </select>`
        }
       ${
        (cfg as any).activityType === 'SECKILL'
          ? ''
          : `
        <input id="rights_${cfg!.id}" data-id="${cfg!.id}" class="rightsinfo-num-input condition-number-input" value="${
              jsonData?.equityInformationRule?.discountValue ?? ''
            }" placeholder="数值" style="width: 50px;height: ${conditionRowInnerHeight}px;"/>
        `
        }`
      }
      </div>
    `;

      return group!.addShape('dom', {
        attrs: {
          width: cfg!.size![0],
          height: cfg!.size![1],
          // 传入 DOM 的 html
          html: `
          <div>
            <div style="background-color: #f2f2f2;border-radius:4px;height: 100%;">
              <div style="background-color: ${
                cfg!.style!.titleBgColor
              }; color: #fff; font-size: 12px;text-align: center;border-radius:4px;height: ${conditionTitleHeight}px;line-height: ${conditionTitleHeight}px;">
              权益信息
              </div>
              <div style="padding: ${conditionContentPaddingY}px ${conditionContentPaddingY * 2}px;">
                <div style="display: flex;">
                  ${conditionHtml}
                </div>
              </div>
            </div>
            ${generateActionBar(cfg)}
          </div>
        `
        }
      });
    }
  });
};
